/**
 * Matomo Analytics — configure REACT_APP_MATOMO_URL (e.g. https://analytics.example.com)
 * and REACT_APP_MATOMO_SITE_ID (numeric site id from Matomo).
 */

function getMatomoConfig() {
  const base = (process.env.REACT_APP_MATOMO_URL || "").trim().replace(/\/$/, "");
  const siteId = (process.env.REACT_APP_MATOMO_SITE_ID || "").trim();
  if (!base || !siteId) return null;
  return { baseUrl: base, siteId };
}

let initStarted = false;

function ensureQueue() {
  window._paq = window._paq || [];
  return window._paq;
}

/** Call once at app bootstrap (e.g. index.js). Loads matomo.js asynchronously. */
export function initMatomo() {
  const cfg = getMatomoConfig();
  if (!cfg || initStarted) return;
  initStarted = true;

  // Page views queued before init must run after the tracker is configured.
  ensureQueue().unshift(
    ["setTrackerUrl", `${cfg.baseUrl}/matomo.php`],
    ["setSiteId", cfg.siteId],
    ["enableLinkTracking"],
  );

  const loadScript = () => {
    if (document.querySelector(`script[src="${cfg.baseUrl}/matomo.js"]`)) return;
    const g = document.createElement("script");
    g.async = true;
    g.src = `${cfg.baseUrl}/matomo.js`;
    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(g, s);
  };

  if (document.hidden) {
    const onVisible = () => {
      document.removeEventListener("visibilitychange", onVisible);
      if (!document.hidden) loadScript();
    };
    document.addEventListener("visibilitychange", onVisible);
    return;
  }

  loadScript();
}

/**
 * SPA page view — use a path-like string (e.g. /home, /landing).
 */
export function trackMatomoPageView(path) {
  if (!getMatomoConfig()) return;
  const _paq = ensureQueue();
  const title = document.title || path;
  _paq.push(["setCustomUrl", path]);
  _paq.push(["setDocumentTitle", title]);
  _paq.push(["trackPageView"]);
}
